import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-86a712c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface ChartData {
  times: string[]
  online: number[]
  offline: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'online-offline-trend-chart',
  props: {
    data: { default: () => ({
    times: [],
    online: [],
    offline: []
  }) },
    modelValue: { default: () => TimeRange.DAYS_30 }
  },
  emits: ["update:modelValue", "timeRangeChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)
const { t, locale } = useI18n()

const cardTitle = computed(() => {
  void locale.value
  return t('groupClient.onlineOfflineTrendTitle')
})

const chartData = computed(() => props.data)
const timeRange = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const seriesConfig = computed(() => {
  void locale.value
  return [
    { field: 'online' as const, name: t('groupClient.online'), color: ECHARTS_LINE_COLOR.success },
    { field: 'offline' as const, name: t('groupClient.offline'), color: ECHARTS_LINE_COLOR.danger },
  ]
})

const chartOption = computed(() => {
  if (!chartData.value?.times?.length) {
    return { xAxis: { data: [] }, series: [] }
  }

  return {
    xAxis: {
      data: chartData.value.times,
    },
    legend: {
      width: chartInstance?.getWidth() ? chartInstance.getWidth() - 60 : 'auto',
    },
    series: seriesConfig.value.map(config => withLineSeriesStyle({
      name: config.name,
      data: chartData.value[config.field as keyof ChartData] as number[],
      smooth: true,
    }, config.color))
  }
})

function initChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
}

function renderChart() {
  if (!chartInstance) return
  const finalOption: any = getAssignLineOption(chartOption.value, { unit: t('portManage.unitTerminal') })
  chartInstance.setOption(finalOption)
}

function handleTimeRangeChange(value: TimeRange, timeRangeArray: [number, number]) {
  timeRange.value = value
  emit('timeRangeChange', value, timeRangeArray)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  if (!chartData.value?.times?.length) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

watch(locale, () => {
  if (!chartInstance) return
  nextTick(() => renderChart())
})

useEchartsThemeSync(renderChart)

onMounted(() => {
  if (chartData.value?.times?.length) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: cardTitle.value,
    class: "online-offline-trend-chart-wrap"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        width: 120,
        onChange: handleTimeRangeChange
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-wrapper"
        }, null, 512)
      ], 512), [
        [_vShow, chartData.value?.times?.length]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "292px",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !chartData.value?.times?.length]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})